import * as React from 'react';

export type TCloseModal = () => void;

export default React.createContext<TCloseModal>(undefined);
